import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
var _excluded = ["attributes"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.promise.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { JSONAPIError } from "../errors/JSONAPIError";
import { NetworkError } from "../errors/NetworkError";
import { getAccessToken } from "../auth/accessToken";
import { API_ROOT } from "./consts";
import { getCsrf, setCsrf } from "./getCsrf";
export var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);
  var _super = _createSuper(AbortError);
  //@ts-expect-error ToDo: fix this

  function AbortError() {
    _classCallCheck(this, AbortError);
    return _super.call(this, 'Request was aborted');
  }
  return _createClass(AbortError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export function request(_x, _x2) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(endpoint, params) {
    var _yield$sendHttpReques, res, req, errorData, err, _data2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(params.schema && params.isExpectedResponse)) {
            _context.next = 2;
            break;
          }
          throw new Error('Can not use both schema and isExpectedResponse at same time');
        case 2:
          if (!(typeof params.defaultResponse !== 'undefined' && !params.isExpectedResponse)) {
            _context.next = 4;
            break;
          }
          throw new Error('Can not use defaultResponse without using isExpectedResponse.  defaultResponse is deprecated and not needed in most cases');
        case 4:
          _context.next = 6;
          return sendHttpRequest(endpoint, params);
        case 6:
          _yield$sendHttpReques = _context.sent;
          res = _yield$sendHttpReques.res;
          req = _yield$sendHttpReques.req;
          _context.prev = 9;
          if (!(res.status === 404 && 'defaultResponse' in params && params.defaultResponse)) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", params.defaultResponse);
        case 12:
          if (res.ok) {
            _context.next = 23;
            break;
          }
          if (!params.throwError) {
            _context.next = 17;
            break;
          }
          _context.next = 16;
          return params.throwError(res);
        case 16:
          throw new Error('An unhandled error occurred');
        case 17:
          _context.next = 19;
          return res.json()["catch"](function () {
            return null;
          });
        case 19:
          errorData = _context.sent;
          if (!(err = JSONAPIError.fromData(errorData))) {
            _context.next = 22;
            break;
          }
          throw err;
        case 22:
          throw new Error(findErrorMessage(errorData));
        case 23:
          _context.next = 25;
          return getData(_objectSpread({
            req: req,
            res: res
          }, params));
        case 25:
          _data2 = _context.sent;
          if (!('isExpectedResponse' in params)) {
            _context.next = 30;
            break;
          }
          if (params.isExpectedResponse(_data2)) {
            _context.next = 29;
            break;
          }
          throw new Error('Unexpected response');
        case 29:
          return _context.abrupt("return", _data2);
        case 30:
          _context.prev = 30;
          return _context.abrupt("return", params.schema.parse(_data2));
        case 34:
          _context.prev = 34;
          _context.t0 = _context["catch"](30);
          console.log(_context.t0);
          if (_context.t0 instanceof Error) {
            Object.assign(_context.t0, _defineProperty({}, dataSymbol, _data2));
          }
          throw _context.t0;
        case 39:
          _context.next = 45;
          break;
        case 41:
          _context.prev = 41;
          _context.t1 = _context["catch"](9);
          attachTraceId(_context.t1, req);
          throw _context.t1;
        case 45:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[9, 41], [30, 34]]);
  }));
  return _request.apply(this, arguments);
}
var dataSymbol = Symbol('data');

/**
 * Gets the data from a parsing error that caused the request to fail
 */
export function getDataFromError(err) {
  return err[dataSymbol];
}
export function attachDataToError(err, data) {
  Object.assign(err, _defineProperty({}, dataSymbol, data));
}
function getData(_x3) {
  return _getData.apply(this, arguments);
}
/**
 * Retrieves the error message from a JSON object received from the server.
 * It assumes that an error already occurred and we just need to find the message.
 *
 * @param errorData
 * @return the error that server sent us. Defaults to 'An error occurred' if we can't find anything.
 */
function _getData() {
  _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
    var req, res, changeToCamelCase, flattenAttributes, deserializer, getData, dataStr, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          req = _ref.req, res = _ref.res, changeToCamelCase = _ref.changeToCamelCase, flattenAttributes = _ref.flattenAttributes, deserializer = _ref.deserializer, getData = _ref.getData;
          if (!(getData && (changeToCamelCase || flattenAttributes || deserializer))) {
            _context2.next = 3;
            break;
          }
          throw new Error('Can not use changeToCamelCase, flattenAttributes, or deserializer when using getData');
        case 3:
          if (!getData) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", getData(res, req));
        case 5:
          if (!(res.status === 204)) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", null);
        case 7:
          _context2.next = 9;
          return res.text();
        case 9:
          dataStr = _context2.sent;
          if (dataStr) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("return", null);
        case 12:
          data = JSON.parse(dataStr, responseReviver({
            changeToCamelCase: changeToCamelCase,
            flattenAttributes: flattenAttributes
          }));
          if (!deserializer) {
            _context2.next = 19;
            break;
          }
          _context2.next = 16;
          return deserializer.deserialize(data);
        case 16:
          _context2.t0 = _context2.sent;
          _context2.next = 20;
          break;
        case 19:
          _context2.t0 = data;
        case 20:
          return _context2.abrupt("return", _context2.t0);
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getData.apply(this, arguments);
}
function findErrorMessage(errorData) {
  var DEFAULT_ERROR = 'An error occurred';
  if (!errorData) {
    return DEFAULT_ERROR;
  }
  if (typeof errorData === 'string') {
    return errorData;
  }
  if (_typeof(errorData) !== 'object' || Array.isArray(errorData)) {
    return DEFAULT_ERROR;
  }
  if (Array.isArray(errorData === null || errorData === void 0 ? void 0 : errorData.errors)) {
    var message = errorData.errors.map(function (errorEntry) {
      var _errorEntry$message;
      return (_errorEntry$message = errorEntry === null || errorEntry === void 0 ? void 0 : errorEntry.message) !== null && _errorEntry$message !== void 0 ? _errorEntry$message : errorEntry === null || errorEntry === void 0 ? void 0 : errorEntry.detail;
    }).filter(Boolean).join(', ');
    if (message.length > 0) {
      return message;
    }
  }
  if (typeof (errorData === null || errorData === void 0 ? void 0 : errorData.error) === 'string') {
    return errorData === null || errorData === void 0 ? void 0 : errorData.error;
  }
  return DEFAULT_ERROR;
}

/**
 * Need to convert the file to FormData to upload it.  Otherwise our API doesn't
 * seem to accept it.
 *
 * fetch will set the 'multipart/form-data' header itself when it sees FormData
 *
 * @see https://stackoverflow.com/a/40826943
 */
export function convertFileToFormData(file) {
  var data = new FormData();
  data.append('file', file);
  return data;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isObject(data) {
  return !!data && !Array.isArray(data) && _typeof(data) === 'object';
}
function hasAttributes(data) {
  return 'attributes' in data;
}
function responseReviver(transformations) {
  return function (_key, value) {
    var data = value;
    if (isObject(data)) {
      if (hasAttributes(data) && transformations.flattenAttributes) {
        var _data = data,
          attributes = _data.attributes,
          rest = _objectWithoutProperties(_data, _excluded);
        data = _objectSpread(_objectSpread({}, attributes), rest);
      }
      if (transformations.changeToCamelCase) {
        data = camelizeProperties(data);
      }
      return data;
    }
    return value;
  };
}

/**
 * @internal Don't export this please
 */
function toCamelCase(str) {
  return str.split('_').reduce(function (acc, part, index) {
    if (index === 0) {
      return "".concat(part[0].toLowerCase()).concat(part.substring(1));
    }
    return "".concat(acc).concat(part[0].toUpperCase()).concat(part.substring(1));
  }, '');
}

/**
 * @internal Don't export this please
 */
function camelizeProperties(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var newKey = key;
    if (typeof key === 'string') {
      newKey = toCamelCase(key);
    }
    //@ts-expect-error ToDo: fix this
    acc[newKey] = obj[key];
    return acc;
  }, {});
}
export function sendHttpRequest(_x4, _x5) {
  return _sendHttpRequest.apply(this, arguments);
}
function _sendHttpRequest() {
  _sendHttpRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(endpoint, params) {
    var isUsingAccessToken, requestHeaders, credentials, token, fetchEndpoint, res, req, _params$signal, newCsrf;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          isUsingAccessToken = false;
          requestHeaders = {
            'x-csrf-token': getCsrf(),
            'X-Requested-With': 'XMLHttpRequest'
          };
          credentials = 'include';
          if (params.body && !(params.body instanceof File) && !(params.body instanceof FormData)) {
            requestHeaders['content-type'] = 'application/json';
          }
          if (!params.contentType) {
            _context3.next = 8;
            break;
          }
          if (!(params.contentType !== 'application/vnd.api+json')) {
            _context3.next = 7;
            break;
          }
          throw new Error('application/vnd.api+json is the only currently supported content-type');
        case 7:
          requestHeaders['content-type'] = params.contentType;
        case 8:
          //@ts-expect-error ToDo: fix this
          if (params.apiKey) {
            //@ts-expect-error ToDo: fix this
            requestHeaders['x-api-key'] = params.apiKey;
            delete requestHeaders['x-csrf-token'];
            delete requestHeaders['X-Requested-With'];
            credentials = 'same-origin';
          }
          if (params.authorization) {
            requestHeaders['Authorization'] = params.authorization;
          }

          //@ts-expect-error ToDo: fix this
          if (!(!params.apiKey && !params.authorization && !params.useSession)) {
            _context3.next = 15;
            break;
          }
          _context3.next = 13;
          return getAccessToken(undefined, {
            allowAnonymous: params.allowAnonymous
          });
        case 13:
          token = _context3.sent;
          if (token) {
            isUsingAccessToken = true;
            requestHeaders['Authorization'] = "Bearer ".concat(token);
            delete requestHeaders['x-csrf-token'];
            delete requestHeaders['X-Requested-With'];
            credentials = 'omit';
          }
        case 15:
          if (params.etag) {
            requestHeaders['If-Match'] = params.etag;
          }
          fetchEndpoint = endpoint.startsWith('http') ? endpoint : "".concat(API_ROOT).concat(endpoint);
          req = new Request(fetchEndpoint, {
            body: params.body instanceof File ? convertFileToFormData(params.body) : params.body instanceof FormData ? params.body : params.body ? JSON.stringify(params.body) : null,
            credentials: credentials,
            headers: requestHeaders,
            method: (params === null || params === void 0 ? void 0 : params.method) || 'GET',
            redirect: params.handleRedirect,
            signal: params.signal
          });
          _context3.prev = 18;
          _context3.prev = 19;
          _context3.next = 22;
          return fetch(req);
        case 22:
          res = _context3.sent;
          _context3.next = 30;
          break;
        case 25:
          _context3.prev = 25;
          _context3.t0 = _context3["catch"](19);
          if (!((_params$signal = params.signal) !== null && _params$signal !== void 0 && _params$signal.aborted)) {
            _context3.next = 29;
            break;
          }
          throw new AbortError();
        case 29:
          throw new NetworkError();
        case 30:
          newCsrf = res.headers.get('x-csrf-token');
          if (!isUsingAccessToken && newCsrf) {
            setCsrf(newCsrf);
          }
          _context3.next = 38;
          break;
        case 34:
          _context3.prev = 34;
          _context3.t1 = _context3["catch"](18);
          attachTraceId(_context3.t1, req);
          throw _context3.t1;
        case 38:
          return _context3.abrupt("return", {
            res: res,
            req: req
          });
        case 39:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[18, 34], [19, 25]]);
  }));
  return _sendHttpRequest.apply(this, arguments);
}
export function attachTraceId(err, req) {
  var traceId = getTraceId(req);
  if (traceId && err instanceof Error) {
    Object.assign(err, {
      traceId: traceId
    });
  }
}
export function getTraceId(req) {
  var _req$headers$get;
  return (_req$headers$get = req.headers.get('traceparent')) === null || _req$headers$get === void 0 ? void 0 : _req$headers$get.split('-')[1];
}